"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isClickable = ui_blocks_1.INTERACTIVE.isClickable,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled,
    isInFocusInverse = ui_blocks_1.INTERACTIVE.isInFocusInverse; // Patterns ==================================================================

var Patterns;

(function (Patterns) {
  Patterns["primary"] = "UTILITY.ACTION";
  Patterns["secondary"] = "GREY.WHITE";
  Patterns["danger"] = "UTILITY.ERROR";
  Patterns["inverse"] = "GREY.WHITE";
})(Patterns || (Patterns = {}));

var PatternsInteractions = {
  primary: {
    hover: 'BLUE["600"]',
    pressed: 'BLUE["700"]'
  },
  secondary: {
    hover: 'GREY["100"]',
    pressed: 'GREY["200"]'
  },
  danger: {
    hover: 'RED["600"]',
    pressed: 'RED["700"]'
  },
  inverse: {
    hover: 'GREY["100"]',
    pressed: 'GREY["200"]'
  }
};

var makePatternStyles = function makePatternStyles(pattern, theme) {
  if (pattern === 'inverse') {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n\n      &:focus,\n      &:focus-visible {\n        ", "\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid ", ";\n        color: ", ";\n        && {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n\n      &:focus,\n      &:focus-visible {\n        ", "\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid ", ";\n        color: ", ";\n        && {\n          background-color: ", ";\n        }\n      }\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern]), theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.DARK", theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].hover), theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].pressed), theme);
    }, isInFocusInverse, (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"400\"]", theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.DARK", theme);
    });
  } else if (pattern === 'secondary') {
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        color: ", ";\n        && {\n          background: ", ";\n        }\n      }\n    "], ["\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        color: ", ";\n        && {\n          background: ", ";\n        }\n      }\n    "])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern]), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.DARK", theme);
    }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].hover), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].pressed), theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"400\"]", theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"200\"]", theme);
    });
  } else if (pattern in Patterns) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      border: 0.0625rem solid\n        ", ";\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n    "], ["\n      border: 0.0625rem solid\n        ", ";\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n      }\n    "])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern]), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern]), theme), (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].hover), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].hover), theme), (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(PatternsInteractions[pattern].pressed), theme);
    });
  }

  return '';
};

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a, _b;

  var sizeMap = {
    tiny: 3,
    small: 4,
    medium: 5
  };
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n  "], ["\n    height: ", ";\n    width: ", ";\n  "])), (0, ui_symbols_1.calcSpace)(sizeMap[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), (0, ui_symbols_1.calcSpace)(sizeMap[size], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
}; // Round =======================================================================


var isRoundStyles = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  border-radius: ", ";\n"], ["\n  border-radius: ", ";\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (0, ui_symbols_1.calcSpace)(3, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}); // Ghost =====================================================================

var isGhostStyles = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  border: none;\n  background: transparent;\n\n  &:hover {\n    border: none;\n  }\n\n  &:disabled,\n  &[aria-disabled='true'],\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: none;\n    && {\n      background: transparent;\n    }\n  }\n"], ["\n  border: none;\n  background: transparent;\n\n  &:hover {\n    border: none;\n  }\n\n  &:disabled,\n  &[aria-disabled='true'],\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: none;\n    && {\n      background: transparent;\n    }\n  }\n"]))); // Outlined =====================================================================

var OutlinePatterns = {
  primary: {
    color: 'UTILITY.ACTION',
    background: 'BLUE["100"]',
    pressed: 'BLUE["200"]',
    border: 'GREY.LIGHT'
  },
  secondary: {
    color: 'GREY.DARK',
    background: 'GREY["300"]',
    pressed: 'GREY.LIGHT',
    border: 'GREY.LIGHT'
  },
  danger: {
    color: 'UTILITY.ERROR',
    background: 'RED["100"]',
    pressed: 'RED["200"]',
    border: 'GREY.LIGHT'
  },
  inverse: {
    color: 'GREY.WHITE',
    background: 'GREY["700"]',
    pressed: 'GREY.MEDIUM',
    border: 'GREY.MEDIUM'
  }
};

var makeOutlinedStyles = function makeOutlinedStyles(pattern, theme) {
  if (pattern === 'inverse') {
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      background: transparent;\n      border: 0.0625rem solid\n        ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid\n          ", ";\n        && {\n          color: ", ";\n          background: transparent;\n        }\n      }\n    "], ["\n      background: transparent;\n      border: 0.0625rem solid\n        ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid\n          ", ";\n        && {\n          color: ", ";\n          background: transparent;\n        }\n      }\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].border), theme);
    }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].color), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].border), theme);
    }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].background), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].color), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].pressed), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["700"]', theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
    });
  } else if (pattern in OutlinePatterns) {
    return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n      background: transparent;\n      border: 0.0625rem solid\n        ", ";\n      color: ", ";\n\n      &:hover {\n        border: ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: ", ";\n      }\n    "], ["\n      background: transparent;\n      border: 0.0625rem solid\n        ", ";\n      color: ", ";\n\n      &:hover {\n        border: ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:active {\n        background: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'],\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: ", ";\n      }\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].border), theme);
    }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].color), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
    }, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].background), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].color), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(OutlinePatterns[pattern].pressed), theme), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
    });
  }

  return '';
};

var Root = styled_components_1.default.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['pattern', 'size', 'isRound', 'isGhost', 'isOutlined', 'hide'].includes(prop);
  }
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  position: relative;\n  background: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n\n  padding: 1px 6px;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'],\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    ", "\n    border: 0.0625rem solid ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n\n  position: relative;\n  background: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n\n  padding: 1px 6px;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'],\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    ", "\n    border: 0.0625rem solid ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), isClickable, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, isDisabled, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["200"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makePatternStyles);
}, function (props) {
  return props.isOutlined && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makeOutlinedStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', makeSizeStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isRound', isRoundStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isGhost', isGhostStyles);
});
exports.Root = Root;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;